import { render, staticRenderFns } from "./EMDocument.vue?vue&type=template&id=797048d0&scoped=true&"
import script from "./EMDocument.vue?vue&type=script&lang=js&"
export * from "./EMDocument.vue?vue&type=script&lang=js&"
import style0 from "./EMDocument.vue?vue&type=style&index=0&id=797048d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797048d0",
  null
  
)

export default component.exports